export default __webpack_public_path__ + "static/media/checkbox.106adb67.svg";